import { render, staticRenderFns } from "./UpdateAccountWorkflowPage.vue?vue&type=template&id=392fe5bc&scoped=true"
import script from "./UpdateAccountWorkflowPage.vue?vue&type=script&lang=js"
export * from "./UpdateAccountWorkflowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392fe5bc",
  null
  
)

export default component.exports